import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { scoreType } from '@/components/10_FuturesKnowledge/types';

export interface FuturesKnowledgeObj {
    index: number;
    question: string;
    answer: scoreType | null;
}
/**
 * @todo Api 回傳值
 */
export interface FuturesKnowledgeViewDataResp extends GeneralResp {
    result: {
        futuresKnowledges: Array<FuturesKnowledgeObj>;
        submitted: boolean;
    };
}

/**
 * @todo 期貨交易知識認知確認表 ViewData
 */
const FuturesKnowledgeViewData = (): Promise<FuturesKnowledgeViewDataResp> => {
    const url = RouteUrlList.API_FuturesKnowledgeViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<FuturesKnowledgeViewDataResp>) => {
        return res.data;
    });
};

export default FuturesKnowledgeViewData;
